export const COMPARE_PARTICLE_TYPE = {
  DATE: 1,
  WEEK: 2,
  MONTH: 3,
  MONTHLY_RATE: 4,
} as const;
